export function RequiredCaret() {
  return <span className="text-sm text-status-red">&#42;</span>;
}
